/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-07-13 11:53:32
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\login\locales\zh-TW.ts
 */
export default {
  'page.user.login.form-item-username': '輸入郵箱/手機號登錄',
  'page.user.login.form-item-username.required': '請輸入用戶名',
  'page.user.login.form-item-password': '輸入密碼',
  'page.user.login.form-item-password.required': '請輸入密碼',
  'page.user.login.form.title': '賬戶登錄',
  'page.user.login.form.btn-submit': '登錄',
  'page.user.login.form.btn-jump': '註冊新賬號',
  'page.user.login.form.login-error': '用戶名或密碼錯誤！',
  'page.user.login.form.login-success': '登錄成功！',
  'page.user.login.form.forgetmsg': '忘記密碼',
  'page.user.login.form.verifica': '請輸入圖形碼',
};
